module.exports = __webpack_public_path__ + "static/media/employer_sign.8eab10f9.png";